import {Machine} from "./machine";

export class MachineGroup {
  machineGroupUuid: string;
  name: string;
  color: string;
  description: string;
  machines: Machine[];
  totalMachines: number;
}
